import Anchor from "@p-ban/common/src/components/html/Anchor"
import Image from "@p-ban/common/src/components/html/Image"

import img from "./referFriendsCouponBanner.png"

const ReferFriendsCouponBanner = () => {
  return (
    <Anchor href="/campaign/refer_friends.html" newTab>
      <Image src={img} alt="お友達紹介で5,000円クーポンゲット! お友達紹介キャンペーン" />
    </Anchor>
  )
}

export default ReferFriendsCouponBanner
